// panel-web/src/components/AlertaDietaOverlay.jsx
import { useEffect, useState } from 'react';
import api from '../api/client';
import { usePermisos } from '../context/PermisosContext';

const POLL_MS = 30000; // cada 30s

export default function AlertaDietaOverlay() {
  const { tienePermiso } = usePermisos();
  const [alertas, setAlertas] = useState([]);
  const [cerrando, setCerrando] = useState(false);

  const puedeVer = tienePermiso('alertas.ver');

  useEffect(() => {
    if (!puedeVer) return;

    let activo = true;
    const consultar = async () => {
      try {
        const { data } = await api.get('/alertas/pendientes');
        if (activo) setAlertas(Array.isArray(data) ? data : []);
      } catch {
        /* silencioso */
      }
    };

    consultar();
    const id = setInterval(consultar, POLL_MS);
    return () => { activo = false; clearInterval(id); };
  }, [puedeVer]);

  if (!puedeVer || alertas.length === 0) return null;

  const alerta = alertas[0];

  const fmtFecha = (f) => {
    if (!f) return '';
    const [a, m, d] = String(f).split('-');
    return `${parseInt(d)}/${parseInt(m)}/${a}`;
  };

  const confirmar = async () => {
    if (cerrando) return;
    setCerrando(true);
    try {
      await api.post(`/alertas/${alerta.id}/vista`);
      setAlertas((prev) => prev.filter((a) => a.id !== alerta.id));
    } catch (err) {
      console.error(err);
    } finally {
      setCerrando(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[99999] flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(6px)' }}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-lg overflow-hidden shadow-2xl"
        style={{ border: '2px solid #0D47A1' }}
      >
        <div
          className="px-6 py-5 text-white flex items-center gap-3"
          style={{ background: 'linear-gradient(to right, #0D47A1, #1565C0)' }}
        >
          <div className="text-4xl">🍽️</div>
          <div>
            <h2 className="text-lg font-bold">Dieta Actualizada</h2>
            <p className="text-xs" style={{ color: '#BBDEFB' }}>
              Notificación del Registro Biólogo
            </p>
          </div>
        </div>

        <div className="p-6 space-y-3">
          <p className="text-sm text-gray-700 leading-relaxed">
            {alerta.mensaje}
          </p>

          <div className="bg-blue-50 border-l-4 border-primary p-3 rounded">
            <div className="text-xs text-gray-500">Sector</div>
            <div className="font-semibold text-primary">{alerta.sector_nombre || '-'}</div>
            <div className="text-xs text-gray-500 mt-2">Fecha</div>
            <div className="font-semibold">{fmtFecha(alerta.fecha)}</div>
          </div>

          <p className="text-xs text-gray-500 italic">
            Este mensaje permanecerá visible hasta que lo confirmes.
          </p>
        </div>

        <div className="px-6 py-4 bg-gray-50 border-t flex justify-end">
          <button
            onClick={confirmar}
            disabled={cerrando}
            className="px-6 py-2 bg-primary text-white rounded-lg text-sm font-medium hover:bg-blue-800 disabled:opacity-50"
          >
            {cerrando ? 'Confirmando…' : '✔ Entendido'}
          </button>
        </div>
      </div>
    </div>
  );
}